module.exports = __webpack_public_path__ + "static/media/heart.294dca67.svg";